'use client';

import Image, { ImageProps } from 'next/image';
import { useState } from 'react';

interface ImageWithSkeletonProps extends ImageProps {
  skeletonClassName?: string;
}

const ImageWithSkeleton = ({
  className = '',
  skeletonClassName = '',
  fill,
  width,
  height,
  alt,
  ...props
}: ImageWithSkeletonProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const shouldFill = fill || (!width && !height);

  const containerStyle = fill ? 'w-full h-full' : '';

  return (
    <div className={`relative ${containerStyle}`} style={!fill ? { width, height } : undefined}>
      {isLoading && (
        <div className={`absolute inset-0 bg-gray-200 animate-pulse ${skeletonClassName}`} />
      )}
      <Image
        className={`${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300 ${className}`}
        fill={shouldFill}
        sizes={shouldFill ? '100%' : undefined}
        width={!shouldFill ? width : undefined}
        height={!shouldFill ? height : undefined}
        alt={alt}
        onLoad={() => setIsLoading(false)}
        {...props}
      />
    </div>
  );
};

export default ImageWithSkeleton;
